import { Vue, Component } from 'vue-property-decorator'
import { validEmail } from '@/galaxy-cruise/utils/validation';
import { api } from '@/galaxy-cruise/api';
import { AxiosError } from 'axios';
import { NOT_ACCEPTABLE, NOT_FOUND } from 'http-status-codes';
import { utf8_to_b64 } from '@/galaxy-cruise/utils/b64utf8';

@Component
export default class extends Vue {
  validateAlways = false
  email = ''

  get emailErrors() {
    return [!validEmail(this.email) && this.$t('invalid_format')].filter((e) => e)
  }

  async submit() {
    if (!this.ok) {
      (this.$refs.dialog as any).shake(() => this.validateAlways = true)
      return
    }

    const axios = api.passErrors(NOT_FOUND)
    try {
      const { email } = this
      await axios.post('../api/v1/password_reset', { email })
      const message = this.$t('mail_sent', { email: this.email }) as string
      this.$router.push(`/message?message=${encodeURIComponent(utf8_to_b64(message))}`)
    } catch (e) {
      const error: AxiosError = e
      switch (error.response!.status) {
        case NOT_FOUND:
          alert(this.$t('no_such_address', { email: this.email }))
          break
      }
    }
  }

  focus() {
    (this.$refs.focus as HTMLInputElement).focus()
  }

  get ok() {
    return this.emailErrors.length === 0
  }

  back() {
    this.$router.back()
  }
}
